import GiftCard from 'src/models/gift-card/GiftCard'
import Model, { encoders, ID, MODEL_LEVEL } from 'src/models/model'
import User from 'src/models/user/User'
import IssuedVoucherPackage from 'src/models/voucher/IssuedVoucherPackage'
import Voucher from 'src/models/voucher/Voucher'
import VoucherType from 'src/models/voucher/VoucherType'

export const TYPES = {
  USER: 'user',
  GIFT_CARD: 'gift-card',
  VOUCHER: 'voucher',
  VOUCHER_PACKAGE: 'voucher-package',
  BLANK_VOUCHER: 'blank-voucher'
}
TYPES.ALL = _.values(TYPES)

export const BARCODE_URL_DELIMITERS = {
  GIFT_CARD: '/g/',
  USER: '/u/'
}
BARCODE_URL_DELIMITERS.ALL = _.values(BARCODE_URL_DELIMITERS)

export const cardNumberRequiresPin = (uid, circuit) => {
  const uidFormatted = uid.replace(/[^a-zA-Z0-9]/g, '')

  return _.some(_.keys(circuit.cardPrefixesRequiringPin), (prefix) => _.startsWith(uidFormatted, prefix))
}

export default class Card extends Model {
  static name = 'Card'

  static level = MODEL_LEVEL.CIRCUIT

  static deletable = true
  static paginate = true
  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Promotions, Model.permissionCategories.HardwareAndRegisterStation]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      uid: {
        type: String,
        required: true
      },
      humanUid: {
        type: String,
        output: true
      },
      user: {
        type: User,
        default: null,
        encode: encoders.hasOne,
        output: true
      },
      voucher: {
        type: Voucher,
        default: null,
        encode: encoders.hasOne
      },
      pin: {
        type: String,
        default: null,
        input: true,
        encode: encoders.if(function () { return this.isLocal })
      },
      giftCard: {
        type: GiftCard,
        default: null,
        encode: encoders.hasOne,
        output: true
      },
      issuedVoucherPackage: {
        type: IssuedVoucherPackage,
        default: null,
        encode: encoders.hasOne,
        output: true
      },
      voucherType: {
        type: VoucherType,
        default: null,
        encode: encoders.hasOne,
        reference: true
      }
    }

    this.queries = {
      cardByUid: {
        arguments: {
          uid: {
            type: String,
            required: true
          },
          pin: {
            type: String,
            required: false
          },
          recaptchaToken: {
            type: String,
            required: false
          }
        },
        results: {
          card: Card
        }
      }
    }
  }

  get isBlank () {
    // A blank card is either not saved in the server, or is saved in the server but not assigned to any applicable models.
    // Applicable models are currently a user, gift card, voucher, or issued voucher package.
    // Cards cannot be assigned to more than one applicable model, as we would not be able to determine which model to activate on card swipe.
    return !this.isRemote || (!this.user && !this.giftCard && !this.voucher && !this.issuedVoucherPackage)
  }
}
